import imports from './indexImports';
import { GlobalHelper, version } from './indexImports'
import React from 'react';
import { render } from 'react-dom';
import PrivateApp from './common/privateapp.component.jsx';
import AppContainer from './appcontainer.component.jsx'
import PublicApp from './common/publicapp.component.jsx'
import 'bootstrap'
import 'react-select/dist/react-select.css'
import 'quill/dist/quill.snow.css'
import TagManager from "react-gtm-module";
import store from './state/store.ts'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 0,
        },
    },
})

let locale = require('browser-locale')()
const queryString = require('query-string')
const parsed = queryString.parse(location.search)

if (parsed.lang) {
    locale = GlobalHelper.formatSupportedLanguage(parsed.lang)
}

let isPublic = false
let app = ''
window.appVersion = version
if (location.protocol !== 'https:') {
    location.href = 'https:' + window.location.href.substring(window.location.protocol.length)
}

if (window.location.pathname.startsWith("/p/")) {
    isPublic = true
    app = <PublicApp />
} else if (window.location.pathname.startsWith("/embed/")) {
    isPublic = false
    app = <PrivateApp emptyFrame={true} />
    document.querySelector("body").setAttribute('style', 'background: white;')
} else {
    isPublic = false
    app = <PrivateApp />
}

TagManager.initialize({
    gtmId: 'GTM-NNBMLVH',
    dataLayerName: 'PageDataLayer'
})

render(
    <QueryClientProvider client={queryClient}>
        <AppContainer locale={locale} isPublic={isPublic} uri={queryString.parse(window.location.search)} >
            <Provider store={store} >
                {app}
            </Provider>
        </AppContainer >
    </QueryClientProvider>,
    document.getElementById('react-container')
)




// WEBPACK FOOTER //
// ./src/index.jsx